<template>
    <div class="rule-content">
        <h3 class="title">
            {{ $t('goldenFlower.rule01Title') }}
        </h3>
        <ol class="list">
            <li v-for="i in 10" :key="i">
                {{ $t(`goldenFlower.rule01_${i}`) }}
            </li>
        </ol>
        <!-- 
            ===================
        -->
        <h3 class="title">
            {{ $t('goldenFlower.rule02Title') }}
        </h3>
        <table class="table">
            <thead>
                <tr>
                    <th>
                        {{ $t('goldenFlower.rule02_column01A') }}
                    </th>
                    <th>{{ $t('goldenFlower.rule02_column02A') }}</th>
                    <th >{{ $t('goldenFlower.rule02_column03A') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(it, idx) in ['B', 'C', 'D', 'E', 'F', 'G']" :key="it">
                    <td>
                        {{ $t(`goldenFlower.rule02_column01${it}`) }}
                    </td>
                    <td v-html="$t(`goldenFlower.rule02_column02${it}`)"></td>
                    <td class="w-[70px]">
                        <div class="relative flex items-center justify-center flex-nowrap">
                            <PokerCard
                                v-for="(val, i) in cardList[idx]"
                                :cardName="val"
                                :real="true"
                                class="absolute"
                                :style="{ left: `${15 * i}px` }"
                                :key="`${idx}-${i}`"
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- 
            ===================
        -->
        <h3 class="title">
            {{ $t('goldenFlower.rule03Title') }}
        </h3>
        <ol class="list">
            <li
                class="break-all"
                v-for="i in [1, 2, 3]"
                :key="i"
                v-html="$t(`goldenFlower.rule03_${i}`)"
            ></li>
        </ol>
        <h3 class="title">
            {{ $t('goldenFlower.rule04Title') }}
        </h3>
        <div class="list break-all" v-html="$t(`goldenFlower.rule04_1`)"></div>
        <h3 class="title">
            {{ $t('goldenFlower.rule05Title') }}
        </h3>
        <div
            class="list break-all"
            v-html="
                $t(`goldenFlower.rule05_1`, {
                    taxRate: (100 - Number(joinStateStore.zhajinhuaGame.rtp)),
                })
            "
        ></div>
    </div>
</template>

<script lang="ts" setup>
import PokerCard from '~/pages/casino/zhajinhuaGame/_components/pokerCard.vue';
import { useJoinStateStore } from '@/stores/cansino/joinState';

const joinStateStore = useJoinStateStore();

const cardList = [
    ['clubsA', 'heartsA', 'spadesA'],
    ['spadesA', 'spadesK', 'spadesQ'],
    ['spadesA', 'spadesK', 'spadesJ'],
    ['spadesA', 'spadesK', 'heartsQ'],
    ['spadesA', 'heartsA', 'spadesK'],
    ['spadesA', 'heartsK', 'spadesJ'],
];
</script>

<style lang="scss" scoped>
.rule-content {
    color: rgba(147, 172, 211, 1);
}

.title {
    color: white;
    font-family: Kanit;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    margin: 0 0 10px;
}

.list {
    margin: 0 0 15px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    padding-left: 1.1em;
    list-style: decimal !important; // 显示数字序号
    li {
        list-style: decimal; // 显示数字序号
    }
}

.table {
    width: 100%;
    text-align: center;
    // border-collapse: separate;
    // border-spacing: 0;
    overflow: hidden;
    border-radius: 10px;
    border-style: hidden; /* 消除掉外边框 */
    border-collapse: collapse; /* 消除单元格之间的空隙 */
    box-shadow: 0 0 0 1px rgba(42, 53, 70, 1); /* hack 一下加个阴影 */
    border: 1px solid rgba(42, 53, 70, 1);
    font-weight: 500;
    font-size: 12px;
    margin: 0 0 15px;

    thead {
        background-color: rgba(27, 38, 54, 1);
        color: white;
    }
    tr th:nth-child(1),
    tr td:nth-child(1) {
        background-color: rgba(28, 37, 50, 1);
        color: white;
    }
    th,
    td {
        min-width: calc(100% / 4);
        max-width: calc(100% / 3);
        border: solid 1px rgba(42, 53, 70, 1);
        padding: 1em 0.5em;
    }
    .unit {
        color: rgba(151, 164, 176, 1);
        font-size: 0.9em;
        font-weight: normal;
    }
}
</style>
